import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/content';
const recap = ['全6巻', '特典5つ', '240ページ', '小1〜中3'];
const reassurances = ['すぐにダウンロード', '印刷できるPDF', '7日間の満足保証'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="19cmdujcaa3h7">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="15fq7w89ona6m" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1eek3bvba1uil">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1ec7m5kdcfo6l">
          あなたの図工・技術の授業は、<em className="text-red-700" data-id="element-118" data-mp="1o43leyr61kce">今日から準備完了。</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="1o4n0m7pflumq">
          題材をさがしたり、ワークシートを一から作ったり、日曜の夜を準備にあてたりする代わりに、1年分の図工・技術の教材が手元にあります。本当に大切なことに、もっと時間を：
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="1x6cv5mem19oq">
          子どもたち。授業。そして、学校の外のあなたの時間。
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="s4fog7xgmj8d">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="x2z9m648bqzo">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="122vdm5cxfif8">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="16503qu461wx4">1回のお支払い · 定期購入ではありません。</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1b3jqgwql3cqj">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1b28mowx524zf" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1ftqf2wl3ix8s">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="1ks1pp9j7tbs2">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="1pszfo8agva44" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}